import { render, staticRenderFns } from "./AccessServices.vue?vue&type=template&id=0c0cee16&lang=pug&"
import script from "./AccessServices.vue?vue&type=script&lang=js&"
export * from "./AccessServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports